import React, { useContext } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { StateContext } from './Context';
import './NoteView.css'

function NoteView() {
    const { savedNotesObj, savedTitlesObj, clickedTitleObj } = useContext(StateContext);
    const [savedNotes] = savedNotesObj;
    // const [savedTitles] = savedTitlesObj;
    const [clickedTitle, setClickedTitle] = clickedTitleObj;


    let { id } = useParams()
    let history = useHistory()

    let clickedNote = savedNotes.filter((item, i) => {
        return i == id;
    })

    // let clickedTitle = savedTitles.filter((item, i) => {
    //     return i == id;
    // })


    return (
        <>
            <div className="Note-view" >
                <button className="home-btn" onClick={() => history.push('/')} >Home</button>

                <h2 >{clickedTitle}</h2>
                {
                    clickedNote.map((note, i) => (
                        <p key={i} >{note.note}</p>
                    ))
                }
            </div>
        </>
    )
}

export default NoteView;
